import { makeStyles, Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) => ({
  instaBookTip: {
    marginRight: theme.spacing(1),
  },
}))
